// extracted by mini-css-extract-plugin
export var active = "_67-7";
export var container = "_67-0";
export var evenWidth = "_67-4";
export var large = "_67-5";
export var outlet = "_67-8";
export var slide = "_67-2";
export var small = "_67-6";
export var tab = "_67-3";
export var tabs = "_67-1";